import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { NavLink } from "react-router-dom-v5-compat";
import { NavDrawerMenuItem } from "../NavDrawerMenuItem";
import { AccountRoutesType, getNavItems } from "../navigationUtils";
export const NavLogOutLink = ({ classes }) => {
    const logoutLink = getNavItems().find((nav) => nav.to === AccountRoutesType.LOGOUT);
    return (_jsx(NavDrawerMenuItem, Object.assign({ component: NavLink, to: logoutLink.to, selected: false, className: classes }, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "flex-start", alignItems: "center", spacing: 1 }, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: logoutLink.displayText })), _jsx(ExitToAppIcon, {})] })) }), logoutLink.to));
};
